import { createAction } from '@reduxjs/toolkit'

import { FetchBrandsActionTypes } from '@store/brands'

export const fetchBrands = createAction<{ context?: string } | undefined>(
  FetchBrandsActionTypes.FETCH_REQUEST,
)

export const fetchBrandsSuccess = createAction<any>(FetchBrandsActionTypes.FETCH_SUCCESS)

export const fetchBrandsError = createAction<any>(FetchBrandsActionTypes.FETCH_ERROR)
